import { InjectionToken } from '@angular/core';
import { IAppEnvironment } from '@domain/environment';

export interface NgRxStoresConfig {
    production: boolean;
    origins: IAppEnvironment['origins'];
}

export const NGRX_STORES_CONFIG = new InjectionToken<NgRxStoresConfig>('ngrx_configs');
